import { useState } from "react";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";

export const AdminLogin = ({ onLogin, api }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return setError("Veuillez saisir le mot de passe.");
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${api}/admin/login`, { password });
      onLogin(data.token);
    } catch (err) {
      setError(err.response?.status === 401 ? "Mot de passe incorrect." : "Erreur de connexion. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-cs-grey px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-2xl border border-cs-navy/10 bg-white p-8 shadow-[0_24px_50px_-24px_rgba(18,48,63,0.35)]">
        <span className="grid h-12 w-12 place-items-center rounded-lg bg-cs-navy text-cs-yellow">
          <Lock className="h-5 w-5" />
        </span>
        <h1 className="mt-5 font-display text-2xl font-extrabold tracking-tight text-cs-navy">Espace administration</h1>
        <p className="mt-1 text-sm text-cs-ink/60">Stop Cheni</p>
        <label htmlFor="admin-password" className="mb-1.5 mt-7 block text-sm font-semibold text-cs-navy">Mot de passe</label>
        <input
          id="admin-password"
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input"
          className={`field ${error ? "field-error" : ""}`}
        />
        {error && <p data-testid="admin-login-error" className="mt-2 text-[13px] font-medium text-red-600">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-button" className="btn-primary mt-6 w-full py-3.5 text-sm">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Se connecter"}
        </button>
        <a href="/" data-testid="admin-back-home" className="mt-5 block text-center text-sm font-medium text-cs-ink/60 hover:text-cs-navy">← Retour au site</a>
      </form>
    </div>
  );
};
